import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from 'questionizer-core'
import styles from './index.scss?inline'
import './index.scss'

//let configPath = document!.querySelector('meta[name="febis-questionizer-config-url"]')?.getAttribute('content');
import config from "./config.json"

if (config !== undefined) {
  const host = document.getElementById('febis-questionizer');
  if (host){
    // @font-face must be in light DOM — browsers don't load fonts from Shadow DOM stylesheets
    if (!document.getElementById('febis-open-sans-fonts')) {
      const fontStyle = document.createElement('style');
      fontStyle.id = 'febis-open-sans-fonts';
      fontStyle.textContent = `
        @font-face { font-display: swap; font-family: 'Open Sans'; font-style: normal; font-weight: 300; src: url('https://questionizer.foerdermittelauskunft.de/de/rockwool/assets/open-sans-v40-latin-300.woff2') format('woff2'); }
        @font-face { font-display: swap; font-family: 'Open Sans'; font-style: normal; font-weight: 400; src: url('https://questionizer.foerdermittelauskunft.de/de/rockwool/assets/open-sans-v40-latin-regular.woff2') format('woff2'); }
        @font-face { font-display: swap; font-family: 'Open Sans'; font-style: normal; font-weight: 500; src: url('https://questionizer.foerdermittelauskunft.de/de/rockwool/assets/open-sans-v40-latin-500.woff2') format('woff2'); }
        @font-face { font-display: swap; font-family: 'Open Sans'; font-style: normal; font-weight: 700; src: url('https://questionizer.foerdermittelauskunft.de/de/rockwool/assets/open-sans-v40-latin-700.woff2') format('woff2'); }
      `;
      document.head.appendChild(fontStyle);
    }

    const shadow = host.attachShadow({ mode: 'open' });
    const mountPoint = document.createElement('div');
    
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styles);
    shadow.adoptedStyleSheets = [sheet];

    console.log("ADOPTED",sheet,  shadow.adoptedStyleSheets);

    shadow.appendChild(mountPoint);

    const footer = document.createElement('div');
    footer.className = 'disclaimer_febis';
    footer.innerHTML = 'Verantwortlicher dieses Inhalts: <a href="https://www.fe-bis.de" target="_blank" style="color:#d20014;text-decoration:none">febis Service GmbH</a> | <a href="https://www.fe-bis.de/datenschutz" target="_blank" style="color:#d20014;text-decoration:none">Datenschutz</a> | <a href="https://www.fe-bis.de/impressum" target="_blank" style="color:#d20014;text-decoration:none">Impressum</a> | <a href="https://www.foerderdata.de/agb" target="_blank" style="color:#d20014;text-decoration:none">Nutzungsbedingungen</a>';
    shadow.appendChild(footer);

    // Alle Accordion-Elemente beim ersten Erscheinen der Ergebnisseite zuklappen
    const accordionObserver = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;
          const root = node.classList.contains('accordion') ? node : node.querySelector('.accordion');
          if (root) {
            root.querySelectorAll<HTMLElement>('.accordion__element_title[aria-expanded="true"]').forEach(btn => btn.click());
          }
        }
      }
    });
    accordionObserver.observe(shadow, { childList: true, subtree: true });

      ReactDOM.createRoot(mountPoint).render(
      <React.StrictMode>
        <App config={config}/>
      </React.StrictMode>);
    }
  }else{
    console.warn("Keine Konfiguration gefunden");
  }